// import { useState } from "react";
import useAuth from "../../hooks/useAuth";
import empty from "../../assets/empty.png";
import { Link } from "react-router-dom";

const MyStore = () => {
  const { user } = useAuth();
  // const [store, setStore] = useState();

  // const getUserStore = async () => {};

  if (!user?.data?.roles[1] && !user?.isSeller?.status)
    return (
      <div className="flex flex-col justify-center mt-10">
        <img src={empty} className="w-fit  m-auto" alt="empty" />
        <p className="text-center">You haven`t created a store yet</p>;
        <button className="font-Lato font-bold text-logoRed bg-none m-auto w-44 -mt-3 rounded-3xl">
          <Link to="/sell-now">Create Store</Link>
        </button>
      </div>
    );
  return <div></div>;
};

export default MyStore;
